/* TEAM 1% — theme interactions */
(function () {
  "use strict";

  /* ---------- header solid on scroll ---------- */
  var header = document.querySelector(".t1-header");
  function onScroll() {
    if (!header) return;
    header.classList.toggle("solid", window.scrollY > 64);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu ---------- */
  var mob = document.querySelector(".t1-mobnav");
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-menu-open]")) mob && mob.classList.add("open");
    if (e.target.closest("[data-menu-close]") || e.target.closest(".t1-mobnav a"))
      mob && mob.classList.remove("open");
  });

  /* ---------- scroll reveal ---------- */
  var revs = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && revs.length) {
    var ro = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            ro.unobserve(en.target);
          }
        });
      },
      { threshold: 0.01, rootMargin: "0px 0px 12% 0px" }
    );
    revs.forEach(function (el) { ro.observe(el); });
    /* Safety net: nada debe quedarse invisible (blanco) en pantalla.
       Revela cualquier elemento que ya esté dentro o por encima del viewport. */
    var sweep = function () {
      revs.forEach(function (el) {
        if (el.classList.contains("in")) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.1) {
          el.classList.add("in");
          ro.unobserve(el);
        }
      });
    };
    window.addEventListener("load", sweep);
    setTimeout(sweep, 1200);
  } else {
    revs.forEach(function (el) { el.classList.add("in"); });
  }

  /* hero reveal on load */
  var hero = document.querySelector(".t1-hero");
  if (hero) requestAnimationFrame(function () { setTimeout(function () { hero.classList.add("in"); }, 80); });

  /* ---------- video autoplay when visible ---------- */
  var vids = document.querySelectorAll("video[data-autoplay]");
  if ("IntersectionObserver" in window) {
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vo.observe(v); });
  }

  /* ---------- counters ---------- */
  var nums = document.querySelectorAll("[data-count]");
  if ("IntersectionObserver" in window && nums.length) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, to = parseFloat(el.getAttribute("data-count")),
            suf = el.getAttribute("data-suffix") || "", pre = el.getAttribute("data-prefix") || "", t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1500, 1);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(to * e) + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        co.unobserve(el);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { co.observe(n); });
  }

  /* ============================================================
     CALCULADORAS DE ENTRENAMIENTO
     ============================================================ */
  var DIST = { "1K":1000,"1.5K":1500,"3K":3000,"5K":5000,"8K":8000,"10K":10000,"15K":15000,"21K":21097.5,"42K":42195 };
  function parseTime(s){ if(!s) return null; var p=s.trim().split(":").map(function(x){return x.trim();}); if(p.some(function(x){return x===""||isNaN(Number(x));})) return null; var n=p.map(Number),sec=0; if(n.length===1)sec=n[0]; else if(n.length===2)sec=n[0]*60+n[1]; else if(n.length===3)sec=n[0]*3600+n[1]*60+n[2]; else return null; return sec>0?sec:null; }
  function pad(n){return String(n).padStart(2,"0");}
  function fmtTime(t){ t=Math.round(t); var h=Math.floor(t/3600),m=Math.floor((t%3600)/60),s=t%60; return h>0?h+":"+pad(m)+":"+pad(s):m+":"+pad(s); }
  function fmtPace(s){ s=Math.round(s); return Math.floor(s/60)+":"+pad(s%60); }
  function pctMax(t){ return 0.8+0.1894393*Math.exp(-0.012778*t)+0.2989558*Math.exp(-0.1932605*t); }
  function vo2(v){ return -4.6+0.182258*v+0.000104*v*v; }
  function velFromVo2(o){ var a=0.000104,b=0.182258,c=-4.6-o; return (-b+Math.sqrt(b*b-4*a*c))/(2*a); }
  function vo2max(m,sec){ var t=sec/60,v=m/t; return vo2(v)/pctMax(t); }
  function predictTime(km,ks,tm){ return ks*Math.pow(tm/km,1.06); }
  var ZONES=[["Fácil (E)","Rodajes base · recuperación",0.7],["Maratón (M)","Ritmo objetivo de maratón",0.84],["Umbral (T)","Tempo · umbral de lactato",0.88],["Intervalo (I)","VO₂máx · series duras",0.98],["Repetición (R)","Velocidad · economía",1.06]];
  var HR=[["Z1 · Recuperación","Regenerativo",0.5,0.6],["Z2 · Aeróbico","Base · quema grasa",0.6,0.7],["Z3 · Tempo","Resistencia aeróbica",0.7,0.8],["Z4 · Umbral","Umbral anaeróbico",0.8,0.9],["Z5 · VO₂máx","Máximo esfuerzo",0.9,1.0]];
  /* Zonas de potencia de ciclismo — % de FTP */
  var PWR=[["Z1 · Recuperación","Activa · regenerativo",0,0.55],["Z2 · Resistencia","Fondo aeróbico",0.56,0.75],["Z3 · Tempo","Ritmo sostenido",0.76,0.90],["Z4 · Umbral","FTP · umbral funcional",0.91,1.05],["Z5 · VO₂máx","Potencia aeróbica máx",1.06,1.20],["Z6 · Anaeróbica","Capacidad anaeróbica",1.21,1.50],["Z7 · Neuromuscular","Sprint · picos",1.51,null]];

  var modal = document.getElementById("t1-calc");
  if (modal) {
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-calc-open]")) { modal.classList.add("open"); document.body.style.overflow="hidden"; }
      if (e.target.closest("[data-calc-close]") || e.target.classList.contains("t1-calc__scrim")) { modal.classList.remove("open"); document.body.style.overflow=""; }
      var tab = e.target.closest("[data-tab]");
      if (tab) {
        var name = tab.getAttribute("data-tab");
        modal.querySelectorAll("[data-tab]").forEach(function(t){t.classList.toggle("on",t===tab);});
        modal.querySelectorAll("[data-panel]").forEach(function(p){p.classList.toggle("on",p.getAttribute("data-panel")===name);});
      }
    });
    document.addEventListener("keydown", function(e){ if(e.key==="Escape"){modal.classList.remove("open");document.body.style.overflow="";} });

    var $=function(s){return modal.querySelector(s);};
    function row(l,m,r,big){ return '<div class="t1-calc__row"><div><span class="'+(big?'l big':'l')+'">'+l+'</span>'+(m?'<span class="m">'+m+'</span>':'')+'</div><span class="r">'+r+'</span></div>'; }
    function empty(t){ return '<div class="t1-calc__empty">'+t+'</div>'; }
    /* lee campos numéricos separados (sin “:” — funciona en teclado de mobile) */
    function num(sel){ var el=$(sel); return el?(parseInt(el.value,10)||0):0; }
    function secHMS(h,m,s){ var t=num(h)*3600+num(m)*60+num(s); return t>0?t:null; }
    function secMS(m,s){ var t=num(m)*60+num(s); return t>0?t:null; }

    function calcPredictor(){
      var d=$("#cp-dist").value, t=secHMS("#cp-h","#cp-m","#cp-s"), out=$("#cp-out");
      if(!t){ out.innerHTML=empty("Escribe tu tiempo para ver la predicción."); return; }
      var m=DIST[d], targets=[["5K",5000],["10K",10000],["Media maratón",21097.5],["Maratón",42195]];
      out.innerHTML='<h4 class="t1-calc__h">Predicción de carrera</h4>'+targets.map(function(x){ var sec=predictTime(m,t,x[1]); return row(x[0],fmtPace((sec/x[1])*1000)+" /km",fmtTime(sec),true); }).join("");
    }
    function calcRitmos(){
      var d=$("#cr-dist").value, t=secHMS("#cr-h","#cr-m","#cr-s"), out=$("#cr-out");
      if(!t){ out.innerHTML=empty("Escribe tu tiempo para calcular tus zonas."); return; }
      var V=vo2max(DIST[d],t);
      var html='<h4 class="t1-calc__h">Zonas de ritmo · /km</h4>';
      html+=ZONES.map(function(z){ var v=velFromVo2(z[2]*V); return row(z[0],z[1],fmtPace((1000/v)*60)); }).join("");
      out.innerHTML=html;
    }
    function calcFC(){
      var age=$("#fc-age").value, mx=$("#fc-max").value, rs=$("#fc-rest").value, out=$("#fc-out");
      var maxHr=mx?Number(mx):(age?220-Number(age):null), rest=rs?Number(rs):60;
      if(!maxHr||maxHr<=rest||maxHr>=230){ out.innerHTML=empty("Ingresa tu edad o FC máx para ver tus zonas."); return; }
      var hrr=maxHr-rest;
      out.innerHTML='<h4 class="t1-calc__h">Zonas de FC · ppm</h4>'+HR.map(function(z){ return row(z[0],z[1],Math.round(rest+z[2]*hrr)+"–"+Math.round(rest+z[3]*hrr)); }).join("");
    }
    function calcVel(){
      var p=secMS("#cv-pmin","#cv-psec"), spd=parseFloat(($("#cv-spd").value||"").replace(",",".")), out=$("#cv-out"), html="";
      if(p) html+=row("Velocidad","desde "+fmtPace(p)+" /km",(3600/p).toFixed(1)+" km/h",true);
      if(spd>0) html+=row("Ritmo","desde "+spd.toFixed(1).replace(".",",")+" km/h",fmtPace(3600/spd)+" /km",true);
      out.innerHTML=html||empty("Escribe tu ritmo o tu velocidad para convertir.");
    }
    function calcPwr(){
      var ftp=parseFloat(($("#pw-ftp").value||"").replace(",",".")), out=$("#pw-out");
      if(!ftp||ftp<=0){ out.innerHTML=empty("Ingresa tu FTP en vatios para ver tus zonas."); return; }
      out.innerHTML='<div class="t1-calc__hl"><span>Tu FTP</span><b>'+Math.round(ftp)+' W</b></div><h4 class="t1-calc__h">Zonas de potencia · vatios</h4>'+PWR.map(function(z){
        var lo=Math.round(z[2]*ftp), hi=z[3]?Math.round(z[3]*ftp):null;
        var pct=z[3]?Math.round(z[2]*100)+"–"+Math.round(z[3]*100)+"%":"> "+Math.round(z[2]*100)+"%";
        return row(z[0],z[1]+" · "+pct,hi?lo+"–"+hi+" W":"> "+lo+" W");
      }).join("");
    }
    modal.addEventListener("input", function(){ calcPredictor(); calcRitmos(); calcVel(); calcPwr(); calcFC(); });
    calcPredictor(); calcRitmos(); calcVel(); calcPwr(); calcFC();
  }

  /* ============================================================
     PRODUCT — variant picker
     ============================================================ */
  var vdata = document.getElementById("t1-variants-data");
  if (vdata) {
    var variants = JSON.parse(vdata.textContent);
    var form = document.getElementById("t1-product-form");
    var idInput = document.getElementById("t1-variant-id");
    var priceEl = document.getElementById("t1-price");
    var atcPrice = document.getElementById("t1-atc-price");
    var atc = document.getElementById("t1-atc");
    var mainImg = document.getElementById("t1-pdp-main");
    var optWraps = Array.prototype.slice.call(document.querySelectorAll(".t1-pdp__opt"));

    function money(cents) {
      var v = (cents / 100).toLocaleString("es-CO");
      return "$" + v;
    }
    function selected() {
      return optWraps.map(function (w) {
        var on = w.querySelector(".t1-opt-btn.on");
        return on ? on.getAttribute("data-value") : null;
      });
    }
    function match(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return !val || v["option" + (i + 1)] === val; });
      });
    }
    function refreshAvailability() {
      var sel = selected();
      optWraps.forEach(function (w, idx) {
        w.querySelectorAll(".t1-opt-btn").forEach(function (btn) {
          var trial = sel.slice();
          trial[idx] = btn.getAttribute("data-value");
          var v = match(trial);
          btn.classList.toggle("soldout", !v || !v.available);
        });
      });
    }
    function update() {
      if (!atc) return;
      var v = match(selected());
      if (!v) {
        atc.setAttribute("disabled", "");
        atc.querySelector("span").textContent = "Combinación no disponible";
        return;
      }
      atc.removeAttribute("disabled");
      atc.querySelector("span").textContent = v.available ? "Añadir al carrito" : "Agotado";
      if (!v.available) atc.setAttribute("disabled", "");
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (atcPrice) atcPrice.textContent = money(v.price);
      if (mainImg && v.featured_image && v.featured_image.src) mainImg.src = v.featured_image.src;
      refreshAvailability();
    }

    optWraps.forEach(function (w) {
      w.addEventListener("click", function (e) {
        var btn = e.target.closest(".t1-opt-btn");
        if (!btn) return;
        w.querySelectorAll(".t1-opt-btn").forEach(function (b) { b.classList.remove("on"); });
        btn.classList.add("on");
        update();
      });
    });

    /* reflect availability on initial load (e.g. sold-out products) */
    update();

    /* thumbnails */
    document.querySelectorAll(".t1-pdp__thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        document.querySelectorAll(".t1-pdp__thumb").forEach(function (x) { x.classList.remove("on"); });
        t.classList.add("on");
        if (mainImg) mainImg.src = t.getAttribute("data-thumb");
      });
    });

    refreshAvailability();
  }
})();
